@if (isShow) {
  <div class="gallery" (click)="onClose()" [class.loading]="isLoading" [class.is-show]="isShow">
    <div class="gallery-inner" #gallery_inner>
      <div class="gallery-content" #gallery_content>
        @if (currentFileIsImage) {
          <img class="gallery-img" (click)="preventCloseOnContent($event)" (load)="onContentLoad()" [src]="currentFilePath" />
        }
        @if (currentFileIsVideo) {
          <video
            class="gallery-video"
            controls
            autoplay
            (click)="preventCloseOnContent($event)"
            (loadeddata)="onContentLoad()"
            [src]="currentFilePath"
          ></video>
        }
        @if (currentFileIsAudio) {
          <audio
            class="gallery-audio"
            controls
            autoplay
            (click)="preventCloseOnContent($event)"
            (loadeddata)="onContentLoad()"
            [src]="currentFilePath"
          ></audio>
        }
        <p class="gallery-caption" #gallery_caption>
          {{ currentFileName }}
        </p>
      </div>
      @if (isLoading) {
        <div class="gallery-loader"></div>
      }
    </div>
  </div>
}
